import { render, staticRenderFns } from "./MultipleRolesModal.vue?vue&type=template&id=73bd4f76&scoped=true&"
import script from "./MultipleRolesModal.vue?vue&type=script&lang=js&"
export * from "./MultipleRolesModal.vue?vue&type=script&lang=js&"
import style0 from "./MultipleRolesModal.vue?vue&type=style&index=0&id=73bd4f76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bd4f76",
  null
  
)

component.options.__file = "MultipleRolesModal.vue"
export default component.exports